import { NgModule } from '@angular/core';

import { QuotesAcceptedQuotesComponent } from './quotes.accepted-quotes.component';
import { QuotesService }                 from './quotes.service';
import { SharedModule }                  from '../shared/shared.module';
import { TableModule }                   from '../table/table.module';

@NgModule({
  declarations: [
    QuotesAcceptedQuotesComponent
  ],
  entryComponents: [
    QuotesAcceptedQuotesComponent
  ],
  exports: [
    QuotesAcceptedQuotesComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    QuotesService
  ]
})
export class QuotesModule {}
